import React from "react"
import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"
import PropTypes from "prop-types"
import { calculateTotals } from "./utils"

const MeasuresFooter = ({
  measures,
  measureCertCheckboxChecked,
  onMeasureCertCheckboxChange,
  measureCertCheckboxDisabled,
}) => {
  const totals = calculateTotals(measures)

  // Helper to format numbers with max two decimals, but without trailing zeros
  const formatMaxTwoDecimals = num => {
    if (typeof num !== "number") return ""
    return num % 1 === 0 ? num : parseFloat(num.toFixed(2)).toString()
  }

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        paddingBlock: "8px",
        borderTop: "1px solid rgba(224, 224, 224, 1)",
        backgroundColor: "#f5f5f5",
        minHeight: "48px",
      }}
    >
      <Box
        sx={{
          flex: 1,
          minWidth: 200,
          display: "flex",
          alignItems: "center",
          gap: 1,
          pl: "10px",
          pr: 1,
          boxSizing: "border-box",
        }}
      >
        <input
          type="checkbox"
          id="measure-cert-checkbox"
          checked={!!measureCertCheckboxChecked}
          disabled={!!measureCertCheckboxDisabled}
          onChange={e => onMeasureCertCheckboxChange?.(e.target.checked)}
          style={{
            width: 16,
            height: 16,
            minWidth: 16,
            minHeight: 16,
            margin: 0,
            flexShrink: 0,
            cursor: measureCertCheckboxDisabled ? "default" : "pointer",
          }}
        />
        <Typography
          component="label"
          htmlFor="measure-cert-checkbox"
          variant="body2"
          sx={{
            margin: 0,
            cursor: measureCertCheckboxDisabled ? "default" : "pointer",
            userSelect: "none",
            lineHeight: 1.2,
          }}
        >
          Certificar por mediciones
        </Typography>
      </Box>
      <Box sx={{ width: 80, flexShrink: 0 }} />
      <Box sx={{ width: 110, flexShrink: 0 }} />
      <Box
        sx={{
          width: 60,
          flexShrink: 0,
          display: "flex",
          justifyContent: "end",
          paddingRight: "10px",
        }}
      >
        <Typography variant="body2" sx={{ fontWeight: "bold" }}>
          {formatMaxTwoDecimals(totals.totalSum)}
        </Typography>
      </Box>

      <Box
        sx={{
          width: 70,
          flexShrink: 0,
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Typography variant="body2" sx={{ fontWeight: "bold" }}>
          {totals.previousPercentageSum.toFixed(2)}%
        </Typography>
      </Box>

      <Box
        sx={{
          width: 90,
          flexShrink: 0,
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Typography variant="body2" sx={{ fontWeight: "bold" }}>
          {totals.previousUnitsSum.toFixed(2)}
        </Typography>
      </Box>

      <Box
        sx={{
          width: 70,
          flexShrink: 0,
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Typography variant="body2" sx={{ fontWeight: "bold" }}>
          {formatMaxTwoDecimals(totals.percentageSum)}%
        </Typography>
      </Box>

      <Box
        sx={{
          width: 60,
          flexShrink: 0,
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Typography variant="body2" sx={{ fontWeight: "bold" }}>
          {totals.unitsSum}
        </Typography>
      </Box>
    </Box>
  )
}

MeasuresFooter.propTypes = {
  measures: PropTypes.arrayOf(
    PropTypes.shape({
      description: PropTypes.string,
      depth: PropTypes.number,
      height: PropTypes.number,
      width: PropTypes.number,
      quantity: PropTypes.number,
      cert_current: PropTypes.number,
      cert_previous: PropTypes.number,
    }),
  ),
  measureCertCheckboxChecked: PropTypes.bool,
  onMeasureCertCheckboxChange: PropTypes.func,
  measureCertCheckboxDisabled: PropTypes.bool,
}

export default MeasuresFooter
